enum OrderBillingForecastReadyForDeliveryType {
  MANUAL_INPUT = 'MANUAL_INPUT',
  CALCULATED_FROM_ORDER_DATE = 'CALCULATED_FROM_ORDER_DATE',
  CALCULATED_FROM_INTEGRATION_DATE = 'CALCULATED_FROM_INTEGRATION_DATE',
}

export default OrderBillingForecastReadyForDeliveryType;
